import axios from "axios";
import { CONST } from "../config/const";

export interface MatrixSettingData {
  sale_companies: { id: number; sale_company_name: string }[];
  products: { id: number; product_name: string; high_rank_company_name: string }[];
  categories: { id: number; category_name: string }[];
  sale_company_groups: { id: number; sale_company_id: number; sale_company_group_name: string }[];
  entry_settings: { sale_company_id: number; product_id: number }[];
  toss_up_settings: { id: number; sale_company_id: number; product_id: number }[];
  closing_partner_settings: { sale_company_toss_up_product_id: number; closer_company_id: number }[];
  closing_category_settings: { sale_company_group_id: number; category_id: number }[];
  collaborate_settings: { sale_company_id: number; collaborate_company_id: number }[];
}

export async function getSaleCompanyMatrixSetting(): Promise<MatrixSettingData | null> {
  try {
    const response = await axios.get(CONST.apiUrl2 + "saleCompanyMatrixSetting");
    return response.data;
  } catch {
    return null;
  }
}

export async function postSaleCompanyMatrixSetting(bodys: {
  entry?: { add: { sale_company_id: number; product_id: number }[]; remove: { sale_company_id: number; product_id: number }[] };
  toss_up?: { add: { sale_company_id: number; product_id: number }[]; remove: { sale_company_id: number; product_id: number }[] };
  closing_partner?: { add: { sale_company_id: number; product_id: number; closer_company_id: number }[]; remove: { sale_company_id: number; product_id: number; closer_company_id: number }[] };
  closing_category?: { add: { sale_company_group_id: number; category_id: number }[]; remove: { sale_company_group_id: number; category_id: number }[] };
  collaborate?: { add: { sale_company_id: number; collaborate_company_id: number }[]; remove: { sale_company_id: number; collaborate_company_id: number }[] };
}): Promise<boolean> {
  try {
    await axios.post(CONST.apiUrl2 + "saleCompanyMatrixSetting", { bodys });
    return true;
  } catch {
    return false;
  }
}
